import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { Mobile } from 'app/models/lyraregistry.model';
import { ApiService } from 'app/services/api.service';
import moment from 'moment-timezone';
import { MomentPipe, FilterPipe } from '../../pipes/pipes';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { Sort, MatSortModule } from '@angular/material/sort';
import { orderBy } from 'lodash';


@Component({
    selector: 'mobile-whitelist',
    templateUrl: './mobile-whitelist.component.html',
    styleUrls: ['./mobile-whitelist.component.css'],
    changeDetection: ChangeDetectionStrategy.Default,
    imports: [RouterLink, FormsModule, TranslateModule, MomentPipe, FilterPipe, MatSortModule]
})
export class MobileWhitelistComponent implements OnInit {

  constructor(
    private api: ApiService,
    private route: ActivatedRoute
  ) {
  }

  mobileWhitelist: Mobile[] = [];


  approveMobile(mobile: Mobile): void {
    this.api.approveWhitelistRequest(mobile.mobileId).subscribe(res => {
      mobile.modified = moment().utc().toDate();
      mobile.approved = true;
    })
  }

  denyMobile(mobile: Mobile): void {
    this.api.denyWhitelistRequest(mobile.mobileId).subscribe(res => {
      this.mobileWhitelist.splice(this.mobileWhitelist.indexOf(mobile), 1);
    })
  }

  editMobile(mobile: Mobile): void {
    mobile.newGsmNumber = mobile.gsmNumber;
    mobile.newName = mobile.name;
    mobile.edit = true;
  }

  saveMobile(mobile: Mobile): void {
    const data = {
      name: mobile.newName,
      gsmNumber: mobile.newGsmNumber
    }
    this.api.updateMobile(mobile.mobileId, data).subscribe(res => {
      mobile.name = mobile.newName;
      mobile.gsmNumber = mobile.newGsmNumber;
      mobile.edit = false;
    })
  }

  sortWhitelist(sort: Sort): void {
    if (!sort.active || sort.direction === '') return;
  
    const approved = this.mobileWhitelist.filter(m => m.approved);
  
    const sorted = orderBy(
      approved,
      [(item) => this.getSortValue(item, sort.active)],
      sort.direction as 'asc' | 'desc'
    );

    const pending = this.mobileWhitelist.filter(m => !m.approved);
  
    this.mobileWhitelist = [...pending, ...sorted];
  }

  private getSortValue(item: Mobile, key: string) {
    switch (key) {
      case 'name':
        return item.name?.toLowerCase();
      case 'gsmNumber':
        return item.gsmNumber;
      case 'modified':
        return new Date(item.modified).getTime();
      default:
        return '';
    }
  }

  ngOnInit(): void {
    this.api.getMobileWhitelist().subscribe(res => {
      this.mobileWhitelist = res;
    })
  }

}
